import { getBaseStatus, getStatusBadgeColor } from '@/utils/projectStatuses';
import './Badge.css';

type BadgeVariant = 'author' | 'reader' | 'contractor' | 'status' | 'price' | 'custom';

interface BadgeProps {
  children?: React.ReactNode;
  variant: BadgeVariant;
  /** Для variant="status" — полное значение state (например "Монтаж: В работе") */
  status?: string | null;
  /** Для variant="custom" — фон и цвет текста */
  bg?: string;
  color?: string;
}

export function Badge({ children, variant, status, bg, color }: BadgeProps) {
  if (variant === 'status' && status != null) {
    const colors = getStatusBadgeColor(status);
    return (
      <span
        className="badge badge_status"
        style={{ backgroundColor: colors.bg, color: colors.color }}
      >
        {getBaseStatus(status)}
      </span>
    );
  }
  if (variant === 'custom' && bg != null && color != null) {
    return (
      <span className="badge badge_status" style={{ background: bg, color }}>
        {children}
      </span>
    );
  }
  return (
    <span className={`badge badge_${variant}`}>
      {children}
    </span>
  );
}
